import * as React from "react"
import { useLayoutEffect, useState } from "react"
import debounce from "lodash/debounce"

// threshold for measuring positon of scroll direction
// for now it is implemented for left and right directions
const _SCROLL_THRESHOLD = 50

// this method handles updating state of button classes.
// it detects if the scroll is to left or right side and sets
// state accordingly
export const handleScrollDirection = (
  event: Event,
  getPosition: () => number,
  setPosition: (position: number) => void,
  callback: (isRight: boolean) => void
) => {
  const container = event.currentTarget as HTMLElement
  const currentPosition = container.scrollLeft
  // now we need to figure out if we need to determine if the list was scrolled
  if (Math.abs(getPosition() - currentPosition) > _SCROLL_THRESHOLD) {
    callback(getPosition() < currentPosition)
    setPosition(currentPosition)
  }
}

export interface Size {
  readonly width: number
  readonly height: number
}

/**
 * An effect (react hook) which returns measured size of an element
 * The ref object must be set to an element during the render phase
 */
export function useElementSize(ref: React.RefObject<HTMLElement>, debounceTime = 0): Size | undefined {
  const [measuredSize, setMeasuredSize] = useState<Size | undefined>(undefined)

  const measure = debounce(() => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect()
      rect && setMeasuredSize({ width: rect.width, height: rect.height })
    }
  }, debounceTime)

  useLayoutEffect(() => {
    !measuredSize && measure()
    window.addEventListener("resize", measure)
    return () => {
      window.removeEventListener("resize", measure)
    }
  }, [])
  return measuredSize
}
